import { useRecordContext } from "react-admin";
import { isEmpty } from "lodash";
import get from "lodash/get";

interface ICustomBooleanField {
  source: string;
  label?: string;
  textForTrueValue: string;
  textForFalseValue: string;
  record?: any;
}

const CustomBooleanField = ({
  record = {},
  source,
  textForTrueValue,
  textForFalseValue,
}: ICustomBooleanField) => {
  const recordContext = useRecordContext();
  const records = isEmpty(record) ? recordContext : record;

  const value = get(records, source);

  return <>{value ? textForTrueValue : textForFalseValue}</>;
};

export default CustomBooleanField;
